var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"detail-content-layout"},[_c('div',{staticClass:"header"},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.label))]),_c('div',{staticClass:"action-area"},[_vm._t("actionArea")],2)]),_c('div',{staticClass:"main"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }